import { render } from "./Telehealth.vue?vue&type=template&id=d637ed64&scoped=true&ts=true"
import script from "./Telehealth.vue?vue&type=script&lang=ts"
export * from "./Telehealth.vue?vue&type=script&lang=ts"

import "./Telehealth.vue?vue&type=style&index=0&id=d637ed64&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d637ed64"]])

export default __exports__